import {FC} from "react";
import {Collapse, Flex, FloatButton, Popover, Typography} from "antd";
import {MessageOutlined} from "@ant-design/icons";
import {SUPPORT_EMAIL} from "../../constants/constants.ts";
import {FeedbackForm} from "../FeedbackForm/FeedbackForm.tsx";

export const FeedbackFloat: FC = () => {
    const content = (
        <Flex vertical gap={16} style={{ width: '500px' }}>
            <Typography.Title level={5}>Что-то пошло не так?</Typography.Title>
            <Collapse
                accordion
                ghost
                items={[
                    {
                        key: 'error',
                        label: 'Интерфейс упал с ошибкой!',
                        children: (
                            <Typography.Paragraph>
                                Все ошибки, которые возникают во время работы, <Typography.Text strong>автоматически</Typography.Text> логгируются системой.
                                <br/><br/>
                                Пожалуйста, <Typography.Text strong>добавь этот сайт в исключения адблокера</Typography.Text> , потому что они иногда мешают работать автоматическим
                                системам аналитики ошибок.
                            </Typography.Paragraph>
                        )
                    },
                    {
                        key: 'non-error',
                        label: 'Ошибки не было, но что-то работает не так',
                        children: (
                            <Flex vertical gap={8}>
                                <Typography.Paragraph>
                                    Так бывает! Чтобы отправить разработчику отчет об ошибке, <Typography.Text strong>напиши что-нибудь в поле ниже и нажми кнопку</Typography.Text>.
                                    К отчету будет прикреплен replay последних нескольких минут работы с сайтом,
                                    чтобы нам было проще разобраться что пошло не так.
                                </Typography.Paragraph>
                                <FeedbackForm />
                            </Flex>
                        )
                    },
                    {
                        key: 'feedback',
                        label: 'Все вроде ок, но я хочу что-то написать',
                        children: (
                            <Typography.Paragraph>
                                Не вопрос - напиши на <Typography.Link href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Typography.Link>
                            </Typography.Paragraph>
                        )
                    }
                ]}
            />
        </Flex>
    )

    return (
        <Popover trigger="click" placement="topLeft" content={content}>
            <FloatButton icon={<MessageOutlined />}/>
        </Popover>
    )
}